import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const reportPost = async ({
	postId,
	reason
}: {
	postId: string;
	reason: string;
}) => {
	const response = await cmsClient.post(`/social-posts/${postId}/report/`, {
		reason
	});
	return response.data;
};

const useReportPost = () => {
	return useMutation(({ postId, reason }: { postId: string; reason: string }) =>
		reportPost({ postId, reason })
	);
};

export default useReportPost;
